import moment from "moment";

moment.locale('pt-br');

new Vue({
    el: '#extracts',
    data: {
        model: {},
        tableData: [],
        startDate: null,
        endDate: null,
        tableApi: null,
        paginationApi: null,
        columns: [
            { value: "Data Ordem", minWidth: 70, maxWidth: 110, fit: true },
            { value: "Número Ordem", minWidth: 80, maxWidth: 120, fit: true },
            { value: "Descrição", minWidth: 120, maxWidth: 160, fit: true },
            { value: "Créditos da Ordem", minWidth: 70, maxWidth: 100, fit: true },
            { value: "Créditos Utilizados", minWidth: 80, maxWidth: 120, fit: true },
            { value: "Créditos Expirados", minWidth: 70, maxWidth: 105, fit: true },
            { value: "Créditos Disponíveis", minWidth: 70, maxWidth: 120, fit: true },
            { value: "Validade da Ordem", minWidth: 80, maxWidth: 110, fit: true },
            { value: "Resgates", minWidth: 70, maxWidth: 160, fit: true },
        ]
    },
    created: function () {
        this.getItems();
    },
    mounted: function () {
        const self = this;

        const startDateElement = document.getElementById("start-date");
        const startDateInput = document.getElementById("start-date-input");
        window.DDS.DatePicker(startDateElement, {
            format: "dd/mm/yyyy",
            localization: {
                invalid: "Data inválida",
                unavailable: "Data indisponível"
            }
        });

        startDateElement.addEventListener("ddsDatePickerSelectDateEvent", (e) => {
            self.startDate = e.detail.date;
            self.filterData();
        });

        startDateInput.addEventListener("change", (e) => {
            const value = e.target.value;

            if (value === "") {
                self.startDate = null;
                self.filterData();
                return;
            }

            if (moment(value, 'DD/MM/YYYY', true).isValid()) {
                self.startDate = value;
                self.filterData();
            }
        });

        const endDateElement = document.getElementById("end-date");
        const endDateInput = document.getElementById("end-date-input");
        window.DDS.DatePicker(endDateElement, {
            format: "dd/mm/yyyy",
            localization: {
                invalid: "Data inválida",
                unavailable: "Data indisponível"
            }
        });

        endDateElement.addEventListener("ddsDatePickerSelectDateEvent", (e) => {
            self.endDate = e.detail.date;
            self.filterData();
        });

        endDateInput.addEventListener("change", (e) => {
            const value = e.target.value;

            if (value === "") {
                self.endDate = null;
                self.filterData();
                return;
            }

            if (moment(value, 'DD/MM/YYYY', true).isValid()) {
                self.endDate = value;
                self.filterData();
            }
        });
    },
    methods: {
        async getItems(page = 1) {
            var self = this;
            let response = await axios.get(
                `${api_url}account/extract?page=${page}`,
                {headers: $headerAuth}
            );

            self.model = response.data;

            this.filterData();
        },
        async getItemsByPage(page) {
            await this.getItems(page);
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#extracts").offset().top - 100
            }, 0);
        },
        async exportPDF() {
            try {
                const response = await axios.get(
                    `${api_url}account/registers/export-credits`,
                    {
                        headers: $headerAuth,
                        responseType: 'blob',
                        params: {
                            orderDesc: true
                        }
                    }
                );

                const contentDisposition = response.headers['content-disposition'];

                let fileName = 'extrato.pdf';

                if (contentDisposition) {

                    const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);

                    if (fileNameMatch.length === 2) {
                        fileName = fileNameMatch[1];
                    }
                }

                const blob = new Blob([response.data], { type: 'application/pdf' });

                const url = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);

                document.body.appendChild(link);

                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

            } catch (error) {
                alert("Não foi possível gerar o PDF. Tente novamente.");
            }
        },
        filterData() {
            if (!this.model.data) {
                return;
            }

            let filteredApiData = this.model.data;

            if (this.startDate) {
                const startMoment = moment(this.startDate, 'DD/MM/YYYY').startOf('day');
                filteredApiData = filteredApiData.filter(row => {
                    const rowDate = moment(row["Data Ordem"], 'DD/MM/YYYY');
                    return rowDate.isSameOrAfter(startMoment);
                });
            }

            if (this.endDate) {
                const endMoment = moment(this.endDate, 'DD/MM/YYYY').endOf('day');
                filteredApiData = filteredApiData.filter(row => {
                    const rowDate = moment(row["Data Ordem"], 'DD/MM/YYYY');
                    return rowDate.isSameOrBefore(endMoment);
                });
            }

            this.tableData = this.transformDataForTable(filteredApiData);

            this.$nextTick(() => {
                this.initializeTable();
            });
        },
        transformDataForTable(apiData) {
            return apiData.map(row => {
                const cells = this.columns.map(column => {
                    const dataKey = column.value;
                    return { value: row[dataKey] !== null ? row[dataKey] : '-' };
                });
                return { columns: cells };
            });
        },
        initializeTable() {
            const tableElement = document.getElementById("extract-table");
            const paginationElement = document.getElementById("extract-table-pagination");

            if (tableElement) {
                if (this.tableApi) {
                    this.tableApi.dispose();
                }

                if (this.paginationApi) {
                    this.paginationApi.dispose();
                }

                this.tableApi = window.DDS.Table(tableElement, {
                    data: this.tableData,
                    columns: this.columns,
                    subscribe: ["extract-table-pagination"],
                    pagination: { currentPage: 1, rowsPerPage: 25 },
                });

                this.paginationApi = window.DDS.Pagination(paginationElement, {
                    subscribe: ["extract-table"],
                });
            }
        },
    }
});
